import React, { useEffect, useMemo, useState } from "react";
import { Box, Grid, InputAdornment, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import TableDryingForms from "./tableDrying";
import TableHumidityForm from "./tableHumidityForm";
import dayjs from "dayjs";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import { formatDateOrNow } from "@app/utils/formatDate";
import useAuth from "@app/context/AuthContext";

const Drying = () => {
  const form = useFormContext();
  const filterSamplingProcedureList = useFilterSamplingProcedure("SEC");
  const { equipmentList } = useEquipment();
  const { userList } = useUser();
  const [humidityValue, setHumidityValue] = useState<number>(-1);
  const [dryingValue, setDryingValue] = useState<number>(-1);
  const watchCapsulesDrying = form.watch("capsules_number_drying");
  const { user } = useAuth();

  const secoCalcinado = useMemo(() => {
    // if (humidityValue > 0 && dryingValue > 0) {
    return dryingValue !== 0 ? (humidityValue / dryingValue).toFixed(2) : null;
    // }
    //return 0;
  }, [humidityValue, dryingValue]);

  useEffect(() => {
    if (!form.getValues("processing_analyst_drying")) {
      form.setValue("processing_analyst_drying", user);
    }
    if (!form.getValues("processing_date_time_drying")) {
      form.setValue("processing_date_time_drying", formatDateOrNow());
    }
    if (!form.getValues("processing_procedure_drying")) {
      form.setValue(
        "processing_procedure_drying",
        filterSamplingProcedureList[0] || undefined
      );
    }

    form.setValue("wet_dry", secoCalcinado);
  }, []);

  useEffect(() => {
    form.setValue("wet_dry", secoCalcinado);
  }, [secoCalcinado]);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{"Secado"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={6} mt={1}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_analyst_drying"))}
          name="processing_analyst_drying"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_procedure_drying"))}
          name="processing_procedure_drying"
          options={filterSamplingProcedureList}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
          validation={{
            required:
              filterSamplingProcedureList.length > 0
                ? "El procedimiento MLPMA es requerido"
                : false,
          }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_equipment_drying"))}
          name="processing_equipment_drying"
          options={equipmentList}
          label="Seleccione un Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "El equipo es requerido" }}
          multiple={true}
        />
        <MDatePicker
          name="processing_date_time_drying"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{ required: "La fecha y hora de inicio es requerida" }}
          maxDate={dayjs(form.watch("processing_date_time_end_drying")) || null}
        />
        <MDatePicker
          name="processing_date_time_end_drying"
          pickerType="datetime"
          label="Fecha y hora Fin"
          minDate={dayjs(form.watch("processing_date_time_drying")) || null}
        />

        <MTextField
          key={JSON.stringify(form.getValues("capsules_number_drying"))}
          name="capsules_number_drying"
          placeholder="Nº de cápsulas"
          label="Nº de cápsulas"
          type="number"
          fullWidth
          validation={{ required: "El número de cápsulas es requerido" }}
        />
      </ResponsiveFormContainer>
      {watchCapsulesDrying > 0 && (
        <>
          <TableHumidityForm
            count={watchCapsulesDrying}
            setHumidityValue={setHumidityValue}
          />
          <TableDryingForms
            count={watchCapsulesDrying}
            setDryingValue={setDryingValue}
            tara={form
              .watch("rowsCurvaDryingCalcination")
              ?.find((row) => row.id === "drying_1")}
          />

          <Box mt={3} sx={{ width: "30%" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Húmedo/Seco:
              <MTextField
                name="wet_dry"
                label="Húmedo/Seco"
                type="number"
                fullWidth
                disabled
              />
            </Typography>
          </Box>
        </>
      )}
    </>
  );
};

export default Drying;
